/**
 * SchemaDropdown Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectSchemas } from '../../../../services/schemas/selectors';

// Utils
import orderBy from '../../../../utils/custom-orderBy';

type State = any;

interface Props {
    general?: boolean;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectGeneral = (state: State, props: Props) => props.general;

const selectData = createDeepEqualSelector(
    selectSchemas,
    schemasState => schemasState && Object.values(schemasState)
);

const selectFilteredData = createDeepEqualSelector(
    [selectData, selectGeneral],
    (dataState, generalState) =>
        dataState.filter(
            value => !value.deletedAt && !value.eventTypeId === !!generalState
        )
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: name
        }))
);

export { selectOptions };
